export default embedded => {
	return embedded && embedded['wp:featuredmedia']
	? embedded['wp:featuredmedia'][0]
	: null;
}
